export default __webpack_public_path__ + "img/img_priya-6b630fdd318906695f175fe1d22cc3ae.png";